import React, { Fragment, useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import style from './trend.css';
import Charts from './charts';
import { classNames } from '../../utils/utils';

const formatData = function formatData(data = []) {
    const xAxisData = [];
    const totalSeriesData = [];
    const perHundredSeriesData = [];

    data.forEach(item => {
        const dateArr = item.date.split(/-/);

        xAxisData.push(`${Number(dateArr[1])}.${Number(dateArr[2])}`);
        totalSeriesData.push(item.total);
        perHundredSeriesData.push(item.per_hundred);
    });

    return { xAxisData, totalSeriesData, perHundredSeriesData };
};

/* 接种趋势 */
const Trend = function Trend(props) {
    const { trend } = props;
    const [type, setType] = useState('total'); // 接种趋势图类型 total或per_hundred
    const divRef = useRef(null);
    const { xAxisData, totalSeriesData, perHundredSeriesData } = useMemo(() => formatData(trend), [trend]);

    // 点击切换图表
    const handleSwitchChartClick = function handleSwitchChartClick(type, event) {
        setType(type);
    };

    return (
        <Fragment>
            <div className={style.box}>
                {type === 'per_hundred' ? (
                    <a
                        className={classNames(style.arrowBtn, style.arrowBtnLeft)}
                        role="button"
                        aria-label="中国累计接种趋势"
                        onClick={event => handleSwitchChartClick('total', event)}
                    />
                ) : (
                    <a
                        className={classNames(style.arrowBtn, style.arrowBtnRight)}
                        role="button"
                        aria-label="中国每百人接种趋势"
                        onClick={event => handleSwitchChartClick('per_hundred', event)}
                    />
                )}
                <div className={style.chartBox}>
                    <div ref={divRef} className={style.chartTab} style={{ right: type === 'per_hundred' ? '100%' : 0 }}>
                        <div className={style.chartTabItem}>
                            <h2 className={style.title}>中国累计接种趋势</h2>
                            <Charts xAxisData={xAxisData} seriesData={totalSeriesData} />
                        </div>
                        <div className={style.chartTabItem}>
                            <h2 className={style.title}>中国每百人接种趋势</h2>
                            <Charts xAxisData={xAxisData} seriesData={perHundredSeriesData} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.tabBox}>
                <a
                    className={classNames(
                        style.trendTab,
                        type === 'total' ? style.trendTabLeftActive : style.trendTabLeft,
                    )}
                    role="button"
                    aria-label="中国累计接种趋势"
                    onClick={event => handleSwitchChartClick('total', event)}
                />
                <a
                    className={classNames(
                        style.trendTab,
                        type === 'per_hundred' ? style.trendTabRightActive : style.trendTabRight,
                    )}
                    role="button"
                    aria-label="中国每百人接种趋势"
                    onClick={event => handleSwitchChartClick('per_hundred', event)}
                />
            </div>
        </Fragment>
    );
};

Trend.propTypes = {
    trend: PropTypes.array,
};

export default Trend;
